export const users: any = [
  { id: 1, name: "John", age: 30, country: "USA", email: "john@example.com" },
  { id: 2, name: "Jane", age: 25, country: "USA", email: "jane@example.com" },
  { id: 3, name: "Doe", age: 40, country: "USA", email: "doe@example.com" },
  { id: 4, name: "Doe", age: 40, country: "USA", email: "doe@example.com" },
  { id: 5, name: "Doe", age: 40, country: "USA", email: "doe@example.com" },
  { id: 6, name: "Doe", age: 40, country: "USA", email: "doe@example.com" },
];

export const usersColumns = [
  { header: "Id", key: "id" },
  { header: "Name", key: "name" },
  { header: "Country", key: "country" },
  { header: "email", key: "email" },
];

  export const generateRowId = (length = 8) => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let id = '';
  for (let i = 0; i < length; i++) {
    id += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return id;
};

  const authorization_token :any= process.env.REACT_APP_AUTHORIZATION_TOKEN;
  export const autoToken: string | null = localStorage.getItem(authorization_token);
